// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useTransferInstructions } from '@hooks/queries/registry/transferInstruction/useTransferInstructions';
import { TransferInstruction } from '@daml.js/splice-api-token-transfer-instruction/lib/Splice/Api/Token/TransferInstructionV1';
import { useParties } from '../../contexts/PartiesContext';
import InterfaceContract from '../../utils/InterfaceContract';

export const useInboundTransferInstructions = () => {
  const { party } = useParties();
  const transform = (allInstructions: InterfaceContract<TransferInstruction>[]) => {
    return allInstructions
      .map((r) => {
        const { transfer } = r.view(TransferInstruction);
        return {
          payload: {
            sender: transfer.sender,
            receiver: transfer.receiver,
          },
        };
      })
      .filter((t) => t.payload?.receiver === party).length;
  };
  return useTransferInstructions(transform);
};
